import LoaderComponent from "components/loader"
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { CardTitle, Container } from "reactstrap"
import { useLazyGetOnboardedInvestorDetailsQuery } from "store/api/wealthpartnerapi/onboard.api"
import OnboardProgressBar from "./onboardProgressBar"
import OnboardInfo from "./onboardInfo"
import PANCard from "./PANCard"
import BusinessAdditionalDetails from "./businessAdditionalDetails"
import BankDetails from "./bankDetails"
import AuthorisedSignatory from "./authorisedSignatory"
import KycAuthorityLetter from "./authorityLetter"
import AgreementDetails from "./agreementDetails"
import OnboardFinalStep from "./onboardFinalStep"
import toast from "react-hot-toast"

const OnboardInvestor = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [getResult, { isFetching }] = useLazyGetOnboardedInvestorDetailsQuery()
  const [kycData, setKycData] = useState(null)
  const [currentStep, setCurrentStep] = useState("")

  useEffect(() => {
    if (id) {
      getInvestorData()
    }
  }, [id])

  const getInvestorData = async () => {
    try {
      const { data } = await getResult({ id }).unwrap()
      setKycData(data)
      setCurrentStep(data.current_step)
    } catch (error) {
      if (error.status === 404) {
        toast.error("Investor not found.", { id: "toastMessage" })
        navigate("/investor-management/onboard")
      }
    }
  }

  document.title = "Onboard Investor | Prachay"

  return (
    <>
      <div className="page-content">
        <div className="container-fluid pb-6">
          <div className="mb-3 mb-md-5">
            <CardTitle className="mb-4 pt-4">
              Onboard Investor({kycData?.investor?.name})
            </CardTitle>
            <OnboardProgressBar kycData={kycData} />
          </div>
          {isFetching && <LoaderComponent />}
          {kycData && (
            <div
              className={`pb-md-5 ${
                kycData?.current_step !== "FINAL_STEP"
                  ? "container-wrapper"
                  : ""
              }`}
            >
              {currentStep === "PAN_GST" && <OnboardInfo kycData={kycData} />}
              {["PAN_GST", "GST_DETAILS", "GST_WAIVER"].includes(
                currentStep
              ) && <PANCard kycData={kycData} />}

              {currentStep === "BUSINESS_ADDITIONAL_DETAILS" && (
                <BusinessAdditionalDetails kycData={kycData} />
              )}
              {["BANK_VERIFICATION", "BANK_DETAILS"].includes(currentStep) && (
                <BankDetails currentStep={currentStep} kycData={kycData} />
              )}

              {["AUTHORISED_SIGNATORY"].includes(currentStep) && (
                <AuthorisedSignatory kycData={kycData} />
              )}

              {currentStep === "AUTHORITY_LETTER" && (
                <KycAuthorityLetter kycData={kycData} />
              )}
              {currentStep === "AGREEMENT_DETAILS" && (
                <AgreementDetails kycData={kycData} />
              )}
              {currentStep === "FINAL_STEP" && (
                <OnboardFinalStep kycData={kycData} />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default OnboardInvestor
